













import { Component, Vue } from 'vue-property-decorator'
import TitleBase from '@/components/atoms/TitleBase.vue'
import TitleTextBase from '@/components/atoms/TitleTextBase.vue'
import ColoredBox from '@/components/atoms/ColoredBox.vue'
import ButtonBase from '@/components/atoms/ButtonBase.vue'

@Component({
  components: {
    TitleBase,
    TitleTextBase,
    ColoredBox,
    ButtonBase,
  },
})
export default class StudentConfirmDone extends Vue {
  private breadcrumbs = [{ text: '申込完了', active: true }]

  private backToStudentList() {
    this.$router.push('/teacher/setting/v3/student')
  }
}
